<template>
<div>
  <v-tooltip top>
    <template v-slot:activator={on}>
      <v-btn
          v-on="on"
          id="botaoAdicionarSalaEspera"
          :outlined="outlined"
          :disabled="disabled"
          icon
          :color="color"
          @click="$emit('adicionarSalaEspera')">
        <v-icon>mdi-sofa-single-outline</v-icon>
      </v-btn>
    </template>
    Adicionar a sala de espera
  </v-tooltip>
</div>
</template>

<script>
export default {
    name: 'BotaoAdicionarSalaEspera',
    props:{
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'white'
        }
    }
}
</script>

<style scoped lang="stylus">

</style>
